export default __webpack_public_path__ + "static/media/google-play1.ab03ba41.png";